export const blockIconsActivitiesSportsBasketballNew = (
	<span className='material-symbols-outlined'>sports_basketball</span>
);
